export { default } from './InsuranceSection';
